import React, {useEffect, useState} from "react";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Footer from "../../../components/footer";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import LoadingSpinner from "../../../components/loading-spinner";
import Input from "../../../components/input";
import {toast, ToastContainer} from 'react-toastify';
import {clear_activity,
    GENERATE_REPORT_EXCEL,
    GENERATE_REPORT_EXCEL_DRIVE,
    generate_report_excel,
    generate_report_excel_drive,
} from "../../../redux/activities";

const ResultsQuery = (props) => {
    let history = useHistory();
    const dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    var date = new Date();

    const _get_all_work_sheets = useSelector((state) => state.work_sheets_module._get_all_work_sheets);
    const _generate_report_excel = useSelector((item) => item.activities_module._generate_report_excel);
    const _generate_report_excel_drive = useSelector((item) => item.activities_module._generate_report_excel_drive);

    const [datas, setDatas] = useState([]);
    const [modal, setModal] = useState(false);
    const [fecha_inicial, setFechaInicial] = useState('');
    const [fecha_final, setFechaFinal] = useState('');

    const [isLoading, setIsLoading] = useState(false);

    const dateStart = new Date(date.getFullYear(), date.getMonth(), 1).toLocaleDateString('en-CA');
    const dateEnd = new Date(date.getFullYear(), date.getMonth() + 1, 0).toLocaleDateString('en-CA');

    const [permisos, setPermisos] = useState([]);

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        if (_get_all_work_sheets.data.datos) {
            let v = _get_all_work_sheets.data.datos.filter(x => x.activo === true);
            setDatas(v);
        }
    }, [_get_all_work_sheets]);

    useEffect(() => {
        if (_generate_report_excel.status === 200) {
            toast.success(_generate_report_excel.data.mensaje);
            dispatch(clear_activity(GENERATE_REPORT_EXCEL));
            setModal(false);
            setIsLoading(false);
        } else if (_generate_report_excel.status !== 0) {
            toast.error(_generate_report_excel.message);
            dispatch(clear_activity(GENERATE_REPORT_EXCEL));
            setIsLoading(false);
        }
    }, [_generate_report_excel, dispatch])

    useEffect(() => {
        if (_generate_report_excel_drive.status === 200) {
            toast.success(_generate_report_excel_drive.data.mensaje);
            dispatch(clear_activity(GENERATE_REPORT_EXCEL_DRIVE));
            setModal(false);
            setIsLoading(false);
        } else if (_generate_report_excel_drive.status !== 0) {
            toast.error(_generate_report_excel_drive.message);
            dispatch(clear_activity(GENERATE_REPORT_EXCEL_DRIVE));
            setIsLoading(false);
        }
    }, [_generate_report_excel_drive, dispatch])

     const handleGenerateReport = (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (fecha_inicial === "") {
            toast.error("Debe seleccionar la fecha inicial");
            setIsLoading(false);
            return;
        }
        if (fecha_final === "") {
            toast.error("Debe seleccionar la fecha final");
            setIsLoading(false);
            return;
        }

        dispatch(generate_report_excel(token, {
            'fecha_inicio': fecha_inicial,
            'fecha_fin': fecha_final
        }));
    }

    const handleGenerateReportDrive = (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (fecha_inicial === "") {
            toast.error("Debe seleccionar la fecha inicial");
            setIsLoading(false);
            return;
        }
        if (fecha_final === "") {
            toast.error("Debe seleccionar la fecha final");
            setIsLoading(false);
            return;
        }

        dispatch(generate_report_excel_drive(token, {
            'fecha_inicio': fecha_inicial,
            'fecha_fin': fecha_final
        }));
    }

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Hoja de trabajo"
                            items={[{label: "Consulta de resultados", link: "/consulta-resultados"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                <div className="row mt-1">
                                    {(permisos.filter(x => x.codigo === 'generar_reporte_excel').length > 0 || permisos.filter(x => x.codigo === 'generar_reporte_excel_drive').length > 0) &&
                                        <div className="col-12 mt-1 mb-1 text-right">
                                            <Button type="button" text="Generar Reporte" theme="calendar"
                                                    onClick={() => {
                                                        setFechaInicial('');
                                                        setFechaFinal('');
                                                        setModal(true);
                                                    }}/>
                                        </div>
                                    }
                                    <div className="mb-1 col-12">
                                        <div className="pl-1 pr-1 border_card">
                                            <p style={{marginTop: 10, fontSize: 18, color: '#727E8C'}}>Consulta de
                                                resultados</p>
                                        </div>
                                    </div>
                                    {datas.length > 0 && (
                                        datas.map((item) => (
                                            <div className="col-md-6 col-12 mb-1">
                                                <div className="d-flex p-1 border_card" style={{cursor: 'pointer'}}
                                                     onClick={() => {
                                                         history.push(`/resultado/${item.id}/${item.nombre}/0/''/${dateStart}/${dateEnd}`);
                                                     }}>
                                                    <div className="d-flex">
                                                        <div className="ml-1">
                                                            <strong className="texto_16">{item.nombre}</strong><br/>
                                                            <strong
                                                                className="texto_14">Procesos: {item.procesos.length}</strong><br/>
                                                            <span className="texto_14">{item.tipo_usuario}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
            <Modal className="modal-main div-modal" show={modal}>
                <form>
                    <div className="card-body">
                        <h5 className="mb-2">Exportar datos</h5>
                        <div className="form-group">
                            <Input
                                type="date"
                                label="Fecha Inicio"
                                onChange={(e) => {
                                    setFechaInicial(e.target.value)
                                }}
                                name='fecha_inicial'
                                value={fecha_inicial}
                            />
                            <Input
                                type="date"
                                label="Fecha Fin"
                                onChange={(e) => {
                                    setFechaFinal(e.target.value)
                                }}
                                name='fecha_final'
                                value={fecha_final}
                            />
                        </div>
                    </div>
                    <div className="card-footer text-center">
                        {(permisos.filter(x => x.codigo === 'generar_reporte_excel').length > 0) &&
                            <button type="button" onClick={handleGenerateReport} className={`btn btn-secondary mb-1 button_div`} disabled={isLoading}>Exportar</button>
                        }
                        {(permisos.filter(x => x.codigo === 'generar_reporte_excel_drive').length > 0) &&
                            <button type="button" onClick={handleGenerateReportDrive} className={`btn btn-success mb-1 button_div`} disabled={isLoading}>Exportar a Drive</button>
                        }
                        <button type="button" onClick={() => {
                            setFechaInicial('');
                            setFechaFinal('');
                            setModal(false);
                        }} className={`btn btn-outline-danger button_div`}>Cancelar
                        </button>
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default ResultsQuery;
